import { createUtility } from '../lib';
export const Margin = createUtility('margin', ({ margin }) => {
    return margin ? `m--${margin}` : null;
});
//# sourceMappingURL=margin.js.map